'use strict'

import ChallengeList from '@/pages/Challenge/ChallengeList.vue'
import ifAuthenticated from '@/router/middleware'

export default [
  {
    path: '/:site/challenges',
    name: 'Challenges',
    component: ChallengeList,
    beforeEnter: ifAuthenticated
  }
]



// WEBPACK FOOTER //
// ./src/router/domains/challenge.js